import { CSS } from '@stitches/react';
import { ReactNode } from 'react';

export interface TableProps {
  children: ReactNode;
  css?: CSS;
}

export interface TableContextProviderProps {
  children: ReactNode;
  value?: any;
}

export interface TableSectionContextProviderProps {
  children: ReactNode;
  value: any;
}

export enum TableSection {
  HEADER = 'header',
  BODY = 'body',
  FOOTER = 'footer',
}

export interface TableSectionContextProps {
  variant: TableSection;
}

export type TableSectionContextValue = TableSectionContextProps | undefined;
